/* BEDRA – free-shipping progress in the cart (14.10.2026).
   Thresholds come from the shop's shipping rates in EUR; the amount left is converted
   to the shopper's currency with Shopify.currency.rate, the same way checkout converts it. */
(function () {
  if (!window.customElements || customElements.get('bedra-ship-progress')) return;
  customElements.define('bedra-ship-progress', class extends HTMLElement {
    connectedCallback() {
      try {
        var rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
        var total = parseInt(this.dataset.total, 10) || 0;
        var threshold = Math.ceil(parseFloat(this.dataset.threshold) * rate * 100);
        if (!threshold) return;
        var text = this.querySelector('.bct__ship');
        var bar = this.querySelector('.bct__bar span');
        var pct = Math.max(0, Math.min(100, (total / threshold) * 100));
        if (bar) bar.style.width = pct + '%';
        var left = threshold - total;
        if (left <= 0) {
          if (text) text.textContent = this.dataset.ok;
          this.classList.add('is-ok');
          return;
        }
        var currency = this.dataset.currency || 'EUR';
        var amount = Math.ceil(left / 100);
        var formatted;
        try {
          formatted = new Intl.NumberFormat(this.dataset.locale || 'en', {
            style: 'currency', currency: currency, minimumFractionDigits: 0, maximumFractionDigits: 0
          }).format(amount);
        } catch (e) {
          formatted = amount + ' ' + currency;
        }
        if (text) text.textContent = (this.dataset.left || '').replace('[amount]', formatted);
      } catch (e) { /* keep the static server-rendered text */ }
    }
  });
})();
